import React from "react";
import { Bell } from "lucide-react";
import { Link } from "wouter";
import { gql, useQuery } from "urql";

export const getMe = gql`
    query {
        me {
            _id
            unreadTicketsCount
        }
    }
`;

export const TicketNotification = (): React.ReactElement => {
    const [{ fetching, error, data }] = useQuery({ query: getMe });
    if (fetching) return <div className="h-9 w-9" />;
    if (error) return <div>{error.toString()}</div>;
    return (
        <Link
            id="tickets-assigned-notification"
            className="relative inline-flex h-9 w-9 items-center justify-center rounded-md !text-white/90 transition-colors hover:bg-white/10 hover:!text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
            to="/tickets"
            title={data.me.unreadTicketsCount > 0 ? "You have unread tickets assigned" : "You have no unread tickets assigned"}
        >
            <Bell className="h-5 w-5" />
            {data.me.unreadTicketsCount > 0 ? (
                <span className="absolute right-1.5 top-1.5 h-2.5 w-2.5 rounded-full bg-amber-400 ring-2 ring-sky-800" />
            ) : null}
        </Link>
    );
};
